define([
    "jquery",
    "underscore",
    "backbone",
    "models/spread_swap_quote_model",
    "templates/trading/crypto_list_item.html"
], function ($, _, Backbone, SpreadSwapQuote, cryptoListTemplate) {
    return Backbone.View.extend({
        el: '#content_layout',

        initialize: function () {
            this.setTimer();
            this.titleBid = $('.quote-title-bid')[0].innerText;
            this.titleAsk = $('.quote-title-ask')[0].innerText;
        },

        setTimer: function () {
            var that = this;
            setTimeout(function () {
                $.when(
                    that.getQuotes()
                ).done(function () {
                    that.setTimer();
                });
            }, 1500);
        },

        getQuotes: function () {
            var that = this;
            var quote = new SpreadSwapQuote();

            var data = {
                'member_type': 'crypto',
                'need_to_sort': false,
                't': $.now()
            };

            // Return the fetch promise
            return quote.fetch({
                data: data,
                success: function (model, response, options) {
                    that.$('#quote_list').html('');
                    _.each(model.get('quotes'), function (element, key, list) {
                        element.titleBid = that.titleBid;
                        element.titleAsk = that.titleAsk;
                        that.$('#quote_list').append(cryptoListTemplate({quote: element}));
                    });
                },
                error: function (model, response, options) {
                }
            });
        },
    });
});
